module.exports = "https://cdn.dashboard.gifty.nl/images/logo.svg?7a970e19c2f1e4533b3f70819b2fad06";